import Container from "../../components/Container"
import Title from "../../components/Title"

import "./Numbers.scss"
import Item from "./components/Item"

const Numbers = () => {
  const content = [
    {
      title: "+70 mil",
      description: "pessoas com dívidas solucionadas todos os meses.",
      icon: "hands",
    },
    {
      title: "+2 bilhões",
      description:
        "em descontos para você quitar dívidas com as melhores condições.",
      icon: "percentage",
      widthLimit: true,
    },
    {
      title: "+1 milhão",
      description: "de pessoas com nome limpo e  reinseridas no crédito. ",
      icon: "coin",
      widthLimit: true,
    },
    {
      title: "100 anos",
      description: "sempre cuidando da sua segurança.",
      icon: "shield",
    },
  ]

  return (
    <div className="landing-numbers">
      <Container>
        <Title className="landing-numbers__title">
          O banco feito de futuro está presente na vida de milhões de pessoas
        </Title>

        <div className="landing-numbers__itens">
          {content.map((item) => {
            return <Item key={item.icon} content={item} />
          })}
        </div>
      </Container>
    </div>
  )
}

export default Numbers
